<template>
  <div class="content-view-page" v-loading="iframeLoading" element-loading-text="页面加载中...">
    <iframe id="iframeSelf" class="iframe" :src="url" width="100%" height="100vh" :key="language_key" @load="handleIframeLoad" @error="handleIframeError"></iframe>
  </div>

</template>

<script>
import { defineComponent, onMounted, ref ,getCurrentInstance,nextTick ,watch, onUnmounted } from 'vue';
import h_i18n from '@/utils/Internationalization';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import {
  getRouteContextInfo,
  shouldNotifyRouteContextInvalid,
  updateRouteContextInfo
} from './routeContext';

export default defineComponent({
  name: 'ContentView',
  setup() {
    const store = useStore()
    const iframeLoading = ref(false)
    let iframeLoadingTimer = null
    let iframeHashNavigationTimer = null
    const { proxy } = getCurrentInstance()
    const url = ref();
    const oldQueryTemp = ref({})

    const queryData = ref({})

    const route = useRoute();
    const router = useRouter();
    const language_key=ref()

    const getSessionRouteInfo = () => {
      if (route.query.routeContextKey) {
        return getRouteContextInfo(route.query.routeContextKey)
      }

      const savedRouteInfo = sessionStorage.getItem('sqm_route_info')
      if (!savedRouteInfo) {
        return null
      }

      try {
        const parsedRouteInfo = JSON.parse(savedRouteInfo)
        return parsedRouteInfo && typeof parsedRouteInfo === 'object' ? parsedRouteInfo : null
      } catch {
        return null
      }
    }

    const redirectForInvalidRouteContext = () => {
      if (shouldNotifyRouteContextInvalid(route.query.routeContextKey)) {
        proxy.warning(h_i18n('1CB0847E02983167140596845DD3CBF6'))
      }
      router.replace({ path: '/Content/WorkBench' })
    }

    watch(() => route.query.routeContextKey, (currentContextKey, previousContextKey) => {
      if (currentContextKey && currentContextKey !== previousContextKey) {
        createUrl()
      }
    })

    watch(() => proxy.$store.state.routeInfo, () => {
      if(route.query.routeContextKey || !proxy.$store.state.routeInfo){
        return 
      }
      console.log('点击菜单-routeInfo',proxy.$store.state.routeInfo.sqm_header_nav)
      // 更新 sqm_header_nav
      sessionStorage.setItem('sqm_header_nav',proxy.$store.state.routeInfo.sqm_header_nav)
      sessionStorage.setItem('view',proxy.$store.state.routeInfo.view)
      createUrl()
    });

    const createUrl = (type) => {
      const sessionRouteInfo = getSessionRouteInfo()
      const routeInfo = route.query.routeContextKey
        ? sessionRouteInfo
        : (sessionRouteInfo || proxy.$store.state.routeInfo)
      if(!routeInfo){
        redirectForInvalidRouteContext()
        return
      }
      queryData.value = { ...routeInfo };
      // 旧会话无完整快照时，沿用原单字段恢复逻辑。
      if (!sessionRouteInfo) {
        if(!sessionStorage.getItem('sqm_header_button_id')){
          for (const key in queryData.value) {
            sessionStorage.setItem(key,queryData.value[key])
          }
          sessionStorage.setItem('pageName','contentPage')
        }else {
          if(type === 'visibilitychange'){
            queryData.value.sqm_header_button_id = sessionStorage.getItem('sqm_header_button_id');
            queryData.value.sqm_header_nav = sessionStorage.getItem('sqm_header_nav');
            queryData.value.sqm_header_type = sessionStorage.getItem('sqm_header_type');
            queryData.value.view = sessionStorage.getItem('view');
          }else{
            queryData.value.sqm_header_button_id = sessionStorage.getItem('sqm_header_button_id');
            queryData.value.sqm_header_nav = sessionStorage.getItem('sqm_header_nav');
            queryData.value.sqm_header_type = sessionStorage.getItem('sqm_header_type');
            queryData.value.view = sessionStorage.getItem('view');
            queryData.value.roleCode = sessionStorage.getItem('roleCode');
          }
        }
      }
      // console.log('queryData---------------->>>>>',queryData)
      // let query = proxy.$store.state.routeInfo;
      let queryString = '?'
      for (const key in queryData.value) {
        if(key != 'view'){
          queryString += `${key}=${queryData.value[key]}&`
        }
      }
      queryString = queryString.substring(0,queryString.length - 1)
      const isHashOnlyNavigation = type !== 'visibilitychange' && type !== 'languagechange' && isHashOnlyIframeNavigation(queryData.value.view)
      startIframeLoading(isHashOnlyNavigation)
      url.value = queryData.value.view + queryString + '&v=' + getIframeVersion()
      // console.log(url.value)
      if(type === 'visibilitychange'){
        language_key.value += queryData.value.roleCode
        sessionStorage.setItem('roleCode',queryData.value.roleCode)
      }
    };
    const getIframeVersion = () => {
      return Date.now()
    }
    const isHashOnlyIframeNavigation = (view) => {
      return Boolean(url.value && view?.includes('#') && url.value.split('#')[0] === view.split('#')[0])
    }
    const clearIframeLoadingTimer = () => {
      if (iframeLoadingTimer !== null) {
        window.clearTimeout(iframeLoadingTimer)
        iframeLoadingTimer = null
      }
      if (iframeHashNavigationTimer !== null) {
        window.clearTimeout(iframeHashNavigationTimer)
        iframeHashNavigationTimer = null
      }
    }
    const startIframeLoading = (isHashOnlyNavigation = false) => {
      clearIframeLoadingTimer()
      iframeLoading.value = true
      if (isHashOnlyNavigation) {
        iframeHashNavigationTimer = window.setTimeout(() => {
          finishIframeLoading()
        }, 300)
        return
      }
      iframeLoadingTimer = window.setTimeout(() => {
        iframeLoading.value = false
        iframeLoadingTimer = null
      }, 10000)
    }
    const finishIframeLoading = () => {
      clearIframeLoadingTimer()
      iframeLoading.value = false
    }
    const handleIframeLoad = () => {
      finishIframeLoading()
    }
    const handleIframeError = () => {
      finishIframeLoading()
    }
    const visibilitychange = (e) =>{
      if (document.visibilityState === "visible") {
        // 判定是否登出
        if(!localStorage.getItem('sqm_is_logged_in') || localStorage.getItem('sqm_is_logged_in') == 'logOut' || localStorage.getItem('sqm_is_logged_in') == 'wait'){
          // router.replace({
          //   path: '/LoginC'
          // });
        }
        const sessionRouteInfo = getSessionRouteInfo()
        if (route.query.routeContextKey && !sessionRouteInfo) {
          redirectForInvalidRouteContext()
          return
        }
        // 当前标签页变为可见状态时，仅同步角色字段，保留本标签页完整业务快照。
        const nextRouteInfo = { ...(sessionRouteInfo || queryData.value) }
        const roleCode = localStorage.getItem('roleCode')
        const hasRoleValue = (value) => value !== null && value.trim() !== ''
        if(nextRouteInfo.view && hasRoleValue(roleCode) && nextRouteInfo.roleCode !== roleCode){
          console.log('角色变化了！！！！！！！', nextRouteInfo.roleCode, roleCode)
          nextRouteInfo.roleCode = roleCode
          const roleFields = ['roleId', 'roleName', 'status', 'type']
          roleFields.forEach((key) => {
            const roleValue = localStorage.getItem(key)
            if (nextRouteInfo[key] !== undefined && nextRouteInfo[key] !== null && hasRoleValue(roleValue)) {
              nextRouteInfo[key] = roleValue
            }
          })

          queryData.value = nextRouteInfo
          if (route.query.routeContextKey) {
            if (!updateRouteContextInfo(route.query.routeContextKey, nextRouteInfo)) {
              redirectForInvalidRouteContext()
              return
            }
          } else {
            sessionStorage.setItem('sqm_route_info', JSON.stringify(nextRouteInfo))
          }
          createUrl('visibilitychange')
        }
      } else {
        // 当前标签页变为不可见状态 store写入sessionStorage
        
        
      }
    }

    onMounted(() => {
      // console.log('onMounted或者刷新页面')
      createUrl()
      
      // window.addEventListener('beforeunload',e=>beforeUnloadHandler(e))
      window.addEventListener('visibilitychange',e=>visibilitychange(e))
      watch(() => store.state.i18n.language, () => {
        startIframeLoading()
        language_key.value=new Date().getTime()
      }, {
        deep: true,
        immediate: true
      });
    });
    onUnmounted(() => {
      clearIframeLoadingTimer()
      window.removeEventListener('visibilitychange',e=>visibilitychange(e))
    })

    return {
      iframeLoading,
      url,
      queryData,
      language_key,
      handleIframeLoad,
      handleIframeError
    };
  }
});
</script>

<style scoped lang="scss">
.content-view-page {
  width: 100%;
  height: calc(100vh - 40px);

  .iframe {
    height: calc(100vh - 70px);
    border: 0;
  }
}
</style>